import { Navigate, useParams } from 'react-router-dom';

export function CreditNoteReviewPage() {
  const { id, noteId } = useParams();
  const note = noteId ? `?note=${encodeURIComponent(noteId)}` : '';
  return <Navigate to={`/invoices/${id || ''}${note}`} replace />;
}
